import TaskType from '../Models/TaskType';
import DataGridRequest from './DataGridRequest';
export class CustomPropertiesDataTypeRequest extends DataGridRequest<TaskType> {
    Url = 'custom_properties/data_types_api';
}
